import { render, staticRenderFns } from "./Inspector.vue?vue&type=template&id=6c0336bd"
import script from "./Inspector.vue?vue&type=script&lang=ts"
export * from "./Inspector.vue?vue&type=script&lang=ts"
import style0 from "./Inspector.vue?vue&type=style&index=0&id=6c0336bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports